export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/building.554096f.svg";